<div class="modal-header" id="participant-copies-modal-title">
    <h3 class="modal-title" id="modal-title" translate="F4M_PARTICIPANTS_CHECKLIST_TITLE"></h3>
    <span class="close" (click)="modalInstance.hide()">&times;</span>
</div>
<div class="modal-body" id="modal-body">
    <div class="ms-2">
        <div class="row bg-secondary p-1 d-none d-md-flex">
            <div class="select-column col-2 ps-2 mt-1">
                <div class="checkbox-container">
                    <input
                        type="checkbox"
                        [ngModel]="selectedAllParticipants$ | async"
                        (change)="onAllSelected()"
                        class="form-control"
                        [attr.aria-label]="'F4M_PARTICIPANTS_SELECT_ALL' | translate"
                    />
                    <fa-icon *ngIf="selectedAllParticipants$ | async" [icon]="faCheck" size="2x"></fa-icon>
                </div>
            </div>
            <div class="col-3 mt-1 col-form-label text-center" translate="F4M_PARTICIPANTS_NAME"></div>
            <div class="col-4 mt-1 text-center col-form-label" translate="F4M_PARTICIPANTS_EMAIL"></div>
            <div class="action-column col-3 mt-1"></div>
        </div>
        <div class="row">
            @if ((participantCopies$ | async)?.length > 0) {
                @for (participant of participantCopies$ | async; track $index; let i = $index) {
                    <pace-forms-participant-list-entry [participant]="participant"></pace-forms-participant-list-entry>
                }
            } @else if ((participantCopies$ | async)?.length === 0) {
                <div class="text-center mt-2" translate="F4M_PARTICIPANTS_NOT_AVAILABLE"></div>
            }
        </div>
    </div>

    <div class="row mt-3">
        <div class="col-md-12 col-5 d-flex">
            <button
                class="btn btn-primary"
                (click)="addParticipant()"
                translate="F4M_PARTICIPANTS_ADD_PARTICIPANT"
            ></button>
        </div>
        @if ((participantCopies$ | async)?.length > 0) {
            <div class="col-7 d-md-none ps-0 text-end">
                <button
                    class="btn btn-primary"
                    (click)="onAllSelected()"
                    translate="F4M_PARTICIPANTS_SELECT_ALL"
                ></button>
            </div>
        }
    </div>
</div>
<div class="modal-footer">
    <button
        class="btn btn-primary ms-auto"
        (click)="copyChecklist()"
        [disabled]="(selectedParticipants$ | async).length === 0"
        translate="F4M_PARTICIPANTS_COPY_CHECKLIST"
    ></button>
</div>
